import { createFileRoute } from '@tanstack/react-router';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { createFeatureFlagGuard } from '@/utils/route-guards/feature-flag-guard';

export const Route = createFileRoute('/$org/$agent/ux-config')({
  beforeLoad: async (ctx) => {
    await createFeatureFlagGuard(AtlasRouteIds.UxConfig)(ctx);
  },
});
